import results from "data/results/education-planning.json";
import RestartButton from "../common/restart-button";
import { QuizAnswers } from "types/quiz";
import useQuizResults from "hooks/useQuizResults";
import CtaBanner from "../common/cta-banner";
import QuizResults from "../common/quiz-results";
import styles from "./results.module.css";

interface ResultsProps {
  quizAnswers: QuizAnswers;
}

const Results = ({ quizAnswers }: ResultsProps) => {
  const { totalScore, result } = useQuizResults(quizAnswers, results);

  if (!result) return <div>Result not found for score: {totalScore}</div>;

  return (
    <>
      <QuizResults result={result} />

      <CtaBanner page="education" />

      <div className={styles.buttonContainer}>
        <RestartButton />
      </div>
    </>
  );
};

export default Results;
